import { useCallback, useMemo, useState } from 'react';

export type PlanKey = 'free' | 'daypass' | 'weekly' | 'monthly' | 'legacy';

export interface PlanStatus {
  planKey: PlanKey;
  planDisplayName: string;
  credits: number;
  creditsAllocated: number;
  periodEnd: string | null;
  daysLeft: number | null;
  isActive: boolean;
  isExpired: boolean;
  isOutOfCredits: boolean;
  isLowCredits: boolean;
  shouldPromptUpgrade: boolean;
  loading: boolean;
  refresh: () => void;
}

/** B2B: no consumer subscriptions table; treat as active with credits for optimize UI. */
export function usePlanStatus(): PlanStatus {
  const [loading, setLoading] = useState(false);
  const refresh = useCallback(() => {
    setLoading(false);
  }, []);
  return useMemo(
    () => ({
      planKey: 'monthly',
      planDisplayName: 'Business',
      credits: 9999,
      creditsAllocated: 9999,
      periodEnd: null,
      daysLeft: null,
      isActive: true,
      isExpired: false,
      isOutOfCredits: false,
      isLowCredits: false,
      shouldPromptUpgrade: false,
      loading,
      refresh,
    }),
    [loading, refresh],
  );
}
